import { actions, initialState } from "./state";

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.CHANGE_FORM_DATA:
      return {
        ...state,
        form_data: action.payload,
      };

    case actions.CHANGE_RIKJANG_ID:
      return {
        ...state,
        rikjang_id: action.payload,
      };

    case actions.CHANGE_RIKJANG:
      return {
        ...state,
        rikjang: action.payload,
      };

    case actions.CHANGE_FORM_HARGA_TARIF_BELI:
      return {
        ...state,
        form_harga_tarif_beli: action.payload,
      };
    case actions.CHANGE_FORM_HARGA_TARIF_JUAL:
      return {
        ...state,
        form_harga_tarif_jual: action.payload,
      };
    case actions.CHANGE_FIELD_TARIF:
      return {
        ...state,
        field_tarif: action.payload,
      };

    case actions.CHANGE_LIST_BARANG:
      return {
        ...state,
        list_barang: action.payload,
      };

    case actions.CHANGE_LIST_JASA:
      return {
        ...state,
        list_jasa: action.payload,
      };

    case actions.CHANGE_LIST_FASILITAS:
      return {
        ...state,
        list_fasilitas: action.payload,
      };
    default:
      return state;
  }
};
